import messenger from './messenger'

export default messenger

export type {
  MessageHandler,
  ChannelMessage,
  MessageTypes,
  SendObjectTreeElementPayload,
} from './messengerTypes'
export type { Messenger } from './messenger'
export { messengerRef } from './messengerRef'
